module.exports = __webpack_public_path__ + "img/air2.08669a00.svg";